import { Link } from 'react-router-dom';
import Reveal from '@/pages/zz-review/components/Reveal';

const entries = [
  {
    key: 'rg',
    icon: 'ri-door-open-line',
    title: 'RG｜1001 Revolving Gate',
    name: '《1001旋轉門》',
    desc: '目前主要的 5D 實踐入口，從閱讀走向一年實踐。',
    status: '現已公開',
    active: true,
  },
  {
    key: 'og',
    icon: 'ri-plant-line',
    title: 'OG｜Oneness Gate',
    name: '《一之門》',
    desc: '完成 1D–5D 築基之後的下一階段生命實踐。',
    status: 'In Development',
    active: false,
  },
  {
    key: 'civilization',
    icon: 'ri-earth-line',
    title: 'Living Civilization',
    name: '生命文明',
    desc: '從個體生命成長走向生命共同體與文明永續。',
    status: 'Coming Soon',
    active: false,
  },
];

export default function StartHereSection() {
  return (
    <section id="start" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-12 md:mb-16">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              START HERE
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              從這裡開始
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
              我今天可以從哪裡開始？現在最清楚、最成熟、最容易進入的答案，就在下面。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-10">
          {entries.map((entry, i) => (
            <Reveal key={entry.key} delay={i * 80}>
              {entry.active ? (
                <Link
                  to="/revolving-gate"
                  className="h-full rounded-lg border border-primary-300/70 bg-background-100 p-6 md:p-7 flex flex-col hover:border-primary-400/80 transition-colors duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-5">
                    <i className={`${entry.icon} text-2xl`} />
                  </div>
                  <p className="text-xs tracking-[0.15em] uppercase text-primary-700 mb-1">
                    {entry.title}
                  </p>
                  <h3
                    className="text-lg md:text-xl text-foreground-900 mb-2"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {entry.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                    {entry.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-800 bg-primary-100 rounded-full px-3 py-1.5 w-fit whitespace-nowrap">
                    <i className="ri-arrow-right-line" />
                    {entry.status}
                  </span>
                </Link>
              ) : (
                <div className="h-full rounded-lg border border-background-200/70 bg-background-100/60 p-6 md:p-7 flex flex-col">
                  <div className="w-12 h-12 flex items-center justify-center rounded-md bg-background-200/70 text-foreground-400 mb-5">
                    <i className={`${entry.icon} text-2xl`} />
                  </div>
                  <p className="text-xs tracking-[0.15em] uppercase text-foreground-400 mb-1">
                    {entry.title}
                  </p>
                  <h3
                    className="text-lg md:text-xl text-foreground-900 mb-2"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {entry.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 flex-1">
                    {entry.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-400 bg-background-100 border border-background-200/70 rounded-full px-3 py-1.5 w-fit whitespace-nowrap">
                    <i className="ri-loader-4-line" />
                    {entry.status}
                  </span>
                </div>
              )}
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="text-center text-sm md:text-base text-foreground-600 leading-relaxed">
            Revolving Gate is the current public START HERE.
          </p>
        </Reveal>
      </div>
    </section>
  );
}